import React from 'react';
import styled from 'styled-components';

import { ToolbarIconButton } from './ToolbarIconButton';
import { Editor } from '@companycam/tiptap-editor';

// #region icons and styled-components
const ToolbarWrapper = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 1000;
  margin-bottom: var(--cc_size_spacing_xl);
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  padding: var(--cc_size_spacing_s);
  background-color: var(--cc_color_background_1);
  border-radius: var(--cc_size_border_radius_l);
  box-shadow: 0px var(--cc_size_depth_2_y) 20px var(--cc_color_depth_2);
  border: 1px solid var(--cc_color_border_default);
`;
// #endregion

export type PageToolbarProps = {
  className?: string;
  editor: Editor;
  onPhotoChoose?: () => void;
};

/**
 *
 * @deprecated - Don't use this directly, make changes to ./PageToolbar and use it through ./index instead.
 */
const PageToolbar = ({
  editor,
  onPhotoChoose,
  className,
}: PageToolbarProps) => {
  if (!editor) {
    return null;
  }

  return (
    <ToolbarWrapper data-testid="page-modal__toolbar" className={className}>
      <ButtonWrapper>
        <ToolbarIconButton
          icon="format-size"
          accessibilityLabel="Text Heading"
          onClick={() =>
            editor.chain().focus().toggleHeading({ level: 2 }).run()
          }
        />
        <ToolbarIconButton
          icon="format-bold"
          accessibilityLabel="Text Bold"
          onClick={() => editor.chain().focus().toggleBold().run()}
          active={editor.isActive('bold')}
        />
        <ToolbarIconButton
          icon="format-italic"
          accessibilityLabel="Text Italic"
          onClick={() => editor.chain().focus().toggleItalic().run()}
          active={editor.isActive('italic')}
        />
        <ToolbarIconButton
          icon="format-underline"
          accessibilityLabel="Text Underline"
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          active={editor.isActive('underline')}
        />
        <ToolbarIconButton
          icon="check-circle-outline"
          accessibilityLabel="Checkbox"
          onClick={() => editor.chain().focus().toggleTaskList().run()}
          active={editor.isActive('taskList')}
        />
        <ToolbarIconButton
          icon="format-list-bulleted"
          accessibilityLabel="Bulleted List"
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          active={editor.isActive('bulletList')}
        />
        <ToolbarIconButton
          icon="format-list-numbered"
          accessibilityLabel="Numbered List"
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          active={editor.isActive('orderedList')}
        />
        {onPhotoChoose ? (
          <ToolbarIconButton
            icon="image-plus-outline"
            accessibilityLabel="Add Image"
            onClick={onPhotoChoose}
          />
        ) : null}
        <ToolbarIconButton
          icon="undo"
          accessibilityLabel="Undo"
          onClick={() => editor.commands.undo()}
        />
        <ToolbarIconButton
          icon="redo"
          accessibilityLabel="Redo"
          onClick={() => editor.commands.redo()}
        />
      </ButtonWrapper>
    </ToolbarWrapper>
  );
};

export default PageToolbar;
